import { idParam, ROLES } from "../../../helpers/commons.helpers";

/**
 * Vehicle route definitions.
 *
 * These routes are lazy-loaded and intended to be used as children of the
 * authenticated layout. Each route exposes a `meta` object with properties
 * used by navigation guards and permission checks.
 *
 * @typedef {Object} VehicleRouteMeta
 * @property {Array<string>} modules - Application module keys related to the route.
 * @property {boolean} requiresAuth - When true the route requires an authenticated session.
 * @property {Array<string>} roles - Array of role identifiers allowed to access the route.
 *
 * @type {Array<import('vue-router').RouteConfig>}
 */
export default [
    {
        path: "/vehicles",
        name: "Vehicles",
        meta: {
            title: "Vehicles",
            modules: ["vehicles"],
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.USER, ROLES.SUPPORT]
        },
        component: () =>
            import(
                /* webpackChunkName: "vehicles" */ "@/modules/vehicles/pages/Vehicles"
            )
    },
    {
        path: "/vehicles/new",
        name: "NewVehicle",
        meta: {
            title: "New Vehicle",
            modules: ["vehicles"],
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.USER, ROLES.SUPPORT]
        },
        component: () =>
            import(
                /* webpackChunkName: "vehicles" */ "@/modules/vehicles/pages/NewVehicle"
            )
    },
    {
        path: `/vehicles/${idParam()}`,
        name: "VehicleDetails",
        meta: {
            title: "Vehicle Details",
            modules: ["vehicles"],
            requiresAuth: true,
            roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER, ROLES.USER, ROLES.SUPPORT]
        },
        component: () =>
            import(
                /* webpackChunkName: "vehicles" */ "@/modules/vehicles/pages/VehicleDetails"
            )
    }
]